import React, { ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../store/store';
import { LoginModal } from './components/LoginModal/LoginModal';
import { useHistory } from 'react-router';
import { AuthState, useAuth } from '../auth/AuthProvider';

export const Login = (): ReactElement => {
  const isShow = useSelector((state: AppState) => state.loginModalVisibility);
  const { isAuthenticated } = useAuth() as AuthState;
  const history = useHistory();

  useEffect((): void => {
    if (isAuthenticated) {
      if (window.location.pathname === '/login') {
        history.push('/');
      }
    }
  }, []);
  if (isShow) {
    return <LoginModal></LoginModal>;
  }

  return <></>;
};
